import React from 'react'
import { BlogComponent } from '../Components/Blog/BlogComponent'

export const Blog = () => {
  return (
    <div>
        <BlogComponent/>
    </div>
  )
}
